import styled from '@emotion/styled/macro'
import emptyResultsImage from 'assets/emptyResults.svg'
import { Text } from 'components'
import { Box, Flex } from 'grid'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

export interface EmptyResultProps {
  text?: string
  isSearchResult?: boolean
}

// const Img = styled.img`
//   min-height: 200px;
//   max-height: 240px;
//   width: 100%;
// `
const Img = styled(Box)`
  background-image: url('${({ src }) => src}');
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center center;
  background-size: contain;
  max-height: 480px;
  min-height: 200px;
`
const Content = styled(Flex)`
  text-align: center;
`

export const EmptyResults: React.FunctionComponent<EmptyResultProps> = ({
  text,
  isSearchResult,
}) => {
  const { t } = useTranslation('EmptyResults')

  return (
    <Content p="5%" flex="1" flexDirection="column">
      <Img flex="1" src={emptyResultsImage} mb={2} />
      <Text font="xxLarge" color="neutralSecondary">
        {text || isSearchResult ? t('searchText') : t('itemText')}
      </Text>
    </Content>
  )
}
